import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/App.css';
import '../styles/Hero.css'; // Ensure this path is correct

function Hero({
  backgroundImage,
  headerText,
  paragraphText,
  primaryButtonText,
  primaryButtonLink,
  secondaryButtonText,
  secondaryButtonLink,
}) {
  return (
    <div className="hero" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="hero-overlay">
        <div className="hero-content">
          <h2 className="hero-header">{headerText}</h2>
          <div className="hero-paragraph">{paragraphText}</div>
          <div className="hero-buttons">
            {primaryButtonText && (
              <Link
                to={primaryButtonLink}
                className="c-ripple primary-button">
                {primaryButtonText}
              </Link>
            )}
            {secondaryButtonText && secondaryButtonLink && (
              <Link
                to={secondaryButtonLink}
                className="c-ripple secondary-button ">
                {secondaryButtonText}
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;